// Pressure boundary vertex schema
// Represents a fixed pressure boundary condition (e.g., connection to atmosphere)

import { z } from 'zod';
import { BaseVertexSchema } from '../base/vertex';
import { ValueWithUnitSchema } from '../base/common';

/**
 * Pressure Boundary Vertex Schema
 * Represents a fixed pressure boundary condition (e.g., connection to atmosphere)
 * 
 * @property elevation - Height of the pressure boundary (for pressure calculations)
 * @property pressure - Pressure value at the boundary
 */
export const PressureBoundaryVertexSchema = BaseVertexSchema.extend({
  type: z.literal('pressure_boundary'),
  elevation: ValueWithUnitSchema,
  pressure: ValueWithUnitSchema,

  // v2: distinguish total vs static pressure for .pipe fidelity
  pressure_type: z.enum(['total', 'static']).optional(),
});

export type PressureBoundaryVertex = z.infer<typeof PressureBoundaryVertexSchema>;

